enum HotelRatingType {
	STARS = 'STARS',
	SQUARES = 'SQUARES',
	CIRCLES = 'CIRCLES',
	OTHER = 'OTHER',
	UNDEFINED = 'UNDEFINED'
}

export default HotelRatingType;